import BASEURLPROJETOS from '../api/authProjetos'
import { buscarOrganizacoesUsuario, buscarProjetosUsuario, loginPayload, recuperarSenhaPayload, novaSenhaCadastrarPayload } from "../../interfaces/auth"

export function buscarOrganizacoes(payload: buscarOrganizacoesUsuario) {
    return BASEURLPROJETOS.post('/auth/organizacoes', payload)
}

export function buscarProjetos(payload: buscarProjetosUsuario) {
    return BASEURLPROJETOS.post('/auth/projetos', payload)
}

export function auth(payload: loginPayload) {
    return BASEURLPROJETOS.post('/auth', payload)
}

export function recuperarSenha(payload: recuperarSenhaPayload) {
    return BASEURLPROJETOS.post('/recuperarsenha', payload)
}

export function novaSenha(payload: novaSenhaCadastrarPayload) {
    return BASEURLPROJETOS.post('/novasenha', payload)
}

